function mergeClassNames(cx, classes, themeClassNames, classNames, name) {
  return Object.keys(classes).reduce((acc, className) => {
    acc[className] = cx(classes[className], themeClassNames !== null && themeClassNames[className], classNames != null && classNames[className], name ? `mantine-${name}-${className}` : null);
    return acc;
  }, {});
}

export { mergeClassNames };
//# sourceMappingURL=merge-class-names.js.map
